import * as React from "react";

/**
 * Kleine Vorschau eines Bildes aus dem Mailtext (15.10.2026: „die Bilder kann
 * man nicht zuordnen, man weiß ja nicht, was das ist"). Lädt das Bild erst,
 * wenn die Zeile sichtbar ist; ein Klick zeigt es groß, ein zweiter wieder
 * klein. Schlägt das Laden fehl, bleibt nur der Platzhalter.
 */
export const MailBildVorschau: React.FC<{
    laden: () => Promise<Blob>;
    name: string;
}> = ({ laden, name }) => {
    const [url, setUrl] = React.useState<string | null>(null);
    const [fehler, setFehler] = React.useState(false);
    const [gross, setGross] = React.useState(false);
    const ladenRef = React.useRef(laden);
    ladenRef.current = laden;

    React.useEffect(() => {
        let aktiv = true;
        let objektUrl: string | null = null;
        // Alles in der Promise-Kette, damit jeder Fehler nur den Platzhalter lässt.
        Promise.resolve()
            .then(() => ladenRef.current())
            .then((blob) => {
                if (!aktiv) return;
                objektUrl = URL.createObjectURL(blob);
                setUrl(objektUrl);
            })
            .catch(() => {
                if (aktiv) setFehler(true);
            });
        return () => {
            aktiv = false;
            if (objektUrl) URL.revokeObjectURL(objektUrl);
        };
    }, []);

    const kasten: React.CSSProperties = {
        flex: "0 0 auto",
        width: gross ? 240 : 44,
        height: gross ? "auto" : 44,
        maxHeight: gross ? 240 : 44,
        borderRadius: 6,
        border: "1px solid var(--vgd-line, #e6e1e5)",
        background: "var(--vgd-bg-2, #f6f3f5)",
        objectFit: "contain",
        display: "block",
    };

    if (!url) {
        return (
            <span
                style={{ ...kasten, width: 44, height: 44 }}
                aria-label={fehler ? `Vorschau für „${name}" nicht verfügbar` : `Vorschau für „${name}" wird geladen`}
                title={fehler ? "Vorschau nicht verfügbar" : "Vorschau wird geladen …"}
            />
        );
    }
    return (
        <button
            type="button"
            onClick={() => setGross((g) => !g)}
            title={gross ? "Klein anzeigen" : "Groß anzeigen"}
            style={{ flex: "0 0 auto", padding: 0, border: 0, background: "none", cursor: "zoom-in" }}
        >
            <img src={url} alt={`Vorschau: ${name}`} style={kasten} />
        </button>
    );
};
